import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { CheckCircle2, ChevronLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import { JobForm } from '@/components/jobs/JobForm'

export default function PostJob() {
  const [isSuccess, setIsSuccess] = useState(false)

  const handleSuccess = () => {
    setIsSuccess(true)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (isSuccess) {
    return (
      <div className="container max-w-2xl py-20 px-4 min-h-[60vh] flex flex-col items-center justify-center text-center animate-fade-in">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
          <CheckCircle2 className="w-10 h-10 text-green-600" />
        </div>
        <h2 className="text-3xl font-bold text-slate-900 mb-4">
          Vaga recebida com sucesso!
        </h2>
        <p className="text-xl text-slate-600 mb-8 max-w-lg">
          Em breve entraremos em contato com candidatos compatíveis com o perfil
          da sua escola.
        </p>
        <Link to="/">
          <Button variant="outline" size="lg">
            Voltar para a página inicial
          </Button>
        </Link>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="container max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center text-slate-500 hover:text-brand-emerald mb-6 transition-colors"
        >
          <ChevronLeft className="w-4 h-4 mr-1" />
          Voltar
        </Link>

        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-extrabold text-brand-navy mb-3">
            Anunciar Nova Vaga
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Preencha os dados abaixo para encontrarmos os melhores educadores
            para sua escola. É gratuito.
          </p>
        </div>

        <JobForm onSuccess={handleSuccess} />
      </div>
    </div>
  )
}
